import { TextareaHTMLAttributes, forwardRef } from "react";
import { clsx } from "clsx";

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    className={clsx("min-h-24 w-full resize-none rounded-md border border-border bg-card px-3 py-2 text-sm text-text placeholder:text-dim focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20 dark:border-border-dark dark:bg-card-dark dark:text-text-dark", className)}
    {...props}
  />
));
Textarea.displayName = "Textarea";
